// extracted by mini-css-extract-plugin
module.exports = {"Switch":"ToggleCF_Switch__26nPb","Slider":"ToggleCF_Slider__1eou-","Round":"ToggleCF_Round__3PKMX"};